import React, { useState,useRef} from "react";
import {
  Card,
  Box,
  Heading,
  Button,
  CardHeader,
  CardBody,
  CardFooter,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerCloseButton,
  DrawerBody,
  Grid,
  FormControl,
  FormLabel,
  Image,
  DrawerFooter,
  Select,
  Input,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Textarea,
  Spinner,
  Switch
} from "@chakra-ui/react";
import { Flex, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import axios from "axios";

import { Cell, LedgerRow, RowActions, StatusMark } from "../../../components/ui";

function KashiCard({ event, Update, Delete }) {
  // const [update, setUpdate] = useState(false);
  const [isDeleteAlertOpenEvent, setIsDeleteAlertOpenEvent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isdisabled, setIsdisabled] = useState(false);
  const {
    isOpen: isOpenEditEvent1,
    onOpen: onOpenEditEvent1,
    onClose: onCloseEditEvent1,
  } = useDisclosure();

  const {
    isOpen: isOpenModal2,
    onOpen: onOpenModal2,
    onClose: onCloseModal2,
  } = useDisclosure();
  const initialRef = useRef(null);
  const [formData, setFormData] = useState({});
  const finalRef = useRef(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "image") {
      let imageD = e.target.files[0];
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: imageD,
      }));
    } else if (name === "eventDate") {
      // Reformat the date value to "dd/mm/yyyy"
      const [year, month, day] = value.split("-");
      const formattedDate = `${day}/${month}/${year}`;

      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: formattedDate,
      }));
    } else if (name.startsWith("gautarm")) {
      const [x, index1, gkey] = name.split("-");

      setFormData((prevFormData) => ({
        ...prevFormData,
        [`gautarm.${index1}.${gkey}`]: value,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };
  const onSubmitUpdate = async (formData, id) => {
    if (formData.image) {
      // setIsdisabled(true);
      let imageUrl = "";
      try {
        const imageData = new FormData();
        imageData.append("file", formData.image);
        imageData.append("upload_preset", "tekxwxfz"); // Replace with your Cloudinary unsigned upload preset

        const response = await axios.post(
          `https://api.cloudinary.com/v1_1/dzidj8k7j/auto/upload`,
          imageData
        );
        imageUrl = response.data.secure_url;
        Update({ ...formData, image: imageUrl }, id);

        
        onCloseEditEvent1();
        setFormData({});
        // setIsdisabled(false);
      } catch (error) {
        console.error(error);
        return;
      }
    } else {
      Update(formData, id);
      onCloseEditEvent1();
        setFormData({});
    }
  };
  return (
    <>
      <LedgerRow stripe={event.paymentStatus ? "paid" : "unpaid"}>
        <Cell full>
          <Text fontWeight={600}>{event.fname} {event.lname}</Text>
          <Text fontSize="sm" color="stone.500">{event.phone}</Text>
        </Cell>
        <Cell label="Date">{event.eventDate}</Cell>
        <Cell label="Prasadam">{event.prasadamStatus && <StatusMark status={event.prasadamStatus} />}</Cell>
        <Cell label="Status"><Flex direction="column" align="flex-start" gap={1}><StatusMark status={event.eventStatus} /><StatusMark status={event.paymentStatus ? "Paid" : "Unpaid"} /></Flex></Cell>
        <Cell label="Notes" full><Text fontSize="sm" noOfLines={2}>{event.authorMessage}</Text></Cell>
        <Cell full>
          <RowActions>
            <Button variant="outline" size="sm" onClick={onOpenModal2}>View</Button>
            <Button as={Link} to={`/admin/usersDtails/${event.userId}`} variant="outline" size="sm">User</Button>
            <Button variant="outline" size="sm" onClick={onOpenEditEvent1}>Edit</Button>
            <Button variant="danger" size="sm" onClick={() => setIsDeleteAlertOpenEvent(true)}>Delete</Button>
          </RowActions>
        </Cell>
      </LedgerRow>

      <Drawer
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpenModal2}
        onClose={onCloseModal2}
        size="lg"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader
          >
            Event Details
          </DrawerHeader>
          <DrawerCloseButton />
          <DrawerBody pb={6}>
            <Grid
              templateColumns={{ base: "1fr", md: "1fr 1fr" }}
              gap={4}
            >
              <FormControl>
                <FormLabel>Full Name</FormLabel>
                <Box>{`${event.fname} ${event.lname ? event.lname : ""}`}</Box>
              </FormControl>

              <FormControl>
                <FormLabel>Mobile number</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.phone}
                </Box>
              </FormControl>

              <FormControl>
                <FormLabel>Email</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.email}
                </Box>
              </FormControl>

              <FormControl>
                <FormLabel>Event Status</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.eventStatus}
                </Box>
              </FormControl>

              <FormControl>
                <FormLabel>Date</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.eventDate}
                </Box>
              </FormControl>

              <FormControl>
                <FormLabel>Prasadam</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.prasadamStatus}
                </Box>
              </FormControl>
              <FormControl>
                <FormLabel>Amount</FormLabel>
                <Box>{event.ammount}</Box>
              </FormControl>
              <FormControl>
                <FormLabel>Payment Status</FormLabel>
                <Box>
                  {event.paymentStatus ? (
                    <span style={{ color: "green" }}>Paid</span>
                  ) : (
                    <span style={{ color: "red" }}>Not Paid</span>
                  )}
                </Box>
              </FormControl>

              <FormControl>
                <FormLabel>City</FormLabel>
                <Box>{event.city ? event.city : "Not recorded"}</Box>
              </FormControl>
              <FormControl>
                <FormLabel> Submitted Date</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.bookingDate}
                </Box>
              </FormControl>
              <FormControl
                width="100%"
              >
                <FormLabel>Expense</FormLabel>
                <Box name="fname">{event.expense}</Box>
              </FormControl>

              <FormControl>
                <FormLabel>Gotram</FormLabel>
                <Box
                  name="gotram"
                  ref={initialRef}
                  placeholder="gotram"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.gotram}
                </Box>
              </FormControl>

              <FormControl>
                <FormLabel>Reference</FormLabel>
                <Box>{event.referedby ? event.referedby : "Not recorded"}</Box>
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Full address</FormLabel>
                <Box
                  name="faddress"
                  ref={initialRef}
                  placeholder="Full Address"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >{`${event.address}, ${event.pincode}`}</Box>
              </FormControl>
              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Nakshatram Details</FormLabel>
                {event.gautarm?.map((el, index) => (
                  <Box key={index}>
                    {el.name && (
                      <>
                        {el.name}
                        {" - "}
                      </>
                    )}
                    {el.gautaram && <>{el.gautaram}</>}
                  </Box>
                ))}
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Message</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.message ? event.message : "Not recorded"}
                </Box>
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Author Message</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.authorMessage ? event.authorMessage : "Not recorded"}
                </Box>
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
              >
                <FormLabel>Event Image</FormLabel>
                <Image
                  src={
                    event.image
                      ? event.image
                      : "https://t4.ftcdn.net/jpg/04/73/25/49/360_F_473254957_bxG9yf4ly7OBO5I0O5KABlN930GwaMQz.jpg"
                  }
                />
              </FormControl>
            </Grid>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <Drawer
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpenEditEvent1}
        onClose={onCloseEditEvent1}
        size="lg"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader
          >
            Edit Event
          </DrawerHeader>
          <DrawerCloseButton />
          <DrawerBody pb={6}>
            <Grid
              templateColumns={{ base: "1fr", md: "1fr 1fr" }}
              gap={4}
            >
              <FormControl>
                <FormLabel>First name</FormLabel>
                <Input
                  name="fname"
                  ref={initialRef}
                  placeholder={event.fname}
                  onChange={handleInputChange}
                  value={formData.fname}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Last name</FormLabel>
                <Input
                  name="lname"
                  placeholder={event.lname}
                  onChange={handleInputChange}
                  value={formData.lname}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Email</FormLabel>
                <Input
                  name="email"
                  placeholder={event.email}
                  onChange={handleInputChange}
                  value={formData.email}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Event Status</FormLabel>
                <Select
                  name="eventStatus"
                  value={formData.eventStatus || event.eventStatus}
                  onChange={handleInputChange}
                >
                  <option value="Pending">Pending</option>
                  <option value="Completed">Completed</option>
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Date</FormLabel>
                <Input
                  type="date"
                  name="eventDate"
                  placeholder={event.eventDate}
                  onChange={handleInputChange}
                  // value={formData.eventDate}
                  min={new Date().toISOString().slice(0, 10)}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Prasadam</FormLabel>
                <Select
                  name="prasadamStatus"
                  value={formData.prasadamStatus || event.prasadamStatus}
                  onChange={handleInputChange}
                >
                  <option value="Undelivered">Undelivered</option>
                  <option value="Delivered">Delivered</option>
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel>Payment</FormLabel>
                <Select
                  name="paymentStatus"
                  value={formData.paymentStatus || event.paymentStatus}
                  onChange={handleInputChange}
                  defaultValue={event.paymentStatus ? "paid" : "notPaid"}
                >
                  <option value={false}>Not Paid</option>
                  <option value={true}>Paid</option>
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel>Amount</FormLabel>
                <Input
                  placeholder={event.ammount}
                  name="ammount"
                  type="number"
                  onChange={handleInputChange}
                  value={formData.ammount}
                />
              </FormControl>
              <FormControl
                width="100%"
              >
                <FormLabel>Upload Image</FormLabel>
                {/* <Input
                  type="file"
                    placeholder="Image"
                    name="image"
                    onChange={handleInputChange}
                  /> */}
                <Input
                  type="file"
                  id="imageMobile"
                  name="image"
                  accept="image/*"
                  onChange={handleInputChange}
                  required
                />
              </FormControl>
              <FormControl>
                <FormLabel>City</FormLabel>
                <Input
                  placeholder={event.city}
                  name="city"
                  type="text"
                  onChange={handleInputChange}
                  value={formData.city}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Expense</FormLabel>
                <Input
                  name="expense"
                  type="number"
                  placeholder={event.expense}
                  onChange={handleInputChange}
                  value={formData.expense}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Gotram</FormLabel>
                <Input
                  name="gotram"
                  placeholder={event.gotram}
                  onChange={handleInputChange}
                  value={formData.gotram}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Reference</FormLabel>
                <Input
                  name="referedby"
                  defaultValue={event.referedby}
                  onChange={handleInputChange}
                  value={formData.referedby}
                />
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Full address</FormLabel>
                <Textarea
                  name="address"
                  defaultValue={event.address}
                  onChange={handleInputChange}
                  value={formData.address}
                />
              </FormControl>
              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Nakshatram Details</FormLabel>
                {event.gautarm?.map((el, index) => (
                  <Box key={index}>
                    <Input
                      width={"50%"}
                      name={`gautarm-${index}-name`}
                      placeholder="Enter Person Name"
                      defaultValue={el.name}
                      onChange={handleInputChange} // Update name field
                    />

                    <Input
                      width={"50%"}
                      name={`gautarm-${index}-gautaram`}
                      placeholder="Enter Nakshatram"
                      defaultValue={el.gautaram}
                      onChange={handleInputChange} // Update gautaram field
                    />
                  </Box>
                ))}
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Author Message</FormLabel>
                <Textarea
                  defaultValue={event.authorMessage}
                  name="authorMessage"
                  onChange={handleInputChange}
                  value={formData.authorMessage}
                />
              </FormControl>
            </Grid>
          </DrawerBody>

          <DrawerFooter>
            <Button
              mr={3}
              disabled={isdisabled || isLoading}
              onClick={() => {
                setIsLoading(true); // Set isLoading to true when the button is clicked
                onSubmitUpdate(formData, event._id).finally(() =>
                  setIsLoading(false)
                ); // Reset isLoading to false after the update is complete or if there's an error
              }}
            >
              {isLoading ? <Spinner size="sm" color="white" /> : "Save"}
            </Button>
            <Button variant="ghost"
              onClick={onCloseEditEvent1}
            >
              Cancel
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>

      <AlertDialog
        isOpen={isDeleteAlertOpenEvent}
        leastDestructiveRef={finalRef}
        onClose={() => setIsDeleteAlertOpenEvent(false)}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Confirmation
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this Event?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button variant="ghost"
                ref={finalRef}
                onClick={() => setIsDeleteAlertOpenEvent(false)}
              >
                Cancel
              </Button>
              <Button variant="dangerSolid"
                onClick={() => {
                  setIsDeleteAlertOpenEvent(false);
                  Delete(event._id);
                }}
                ml={3}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}

export default KashiCard;
